import { LuImage, LuSmartphone } from 'react-icons/lu'

import { Alert } from '@vtex/shoreline'

import Panel from '~/components/Panel'
import { useAPPTranslation } from '~/i18n/useAPPTranslation'

import {
  GuideBody,
  GuideGroup,
  GuideGroupIcon,
  GuideGroupTitle,
  GuideList,
  GuideTip
} from './SizeGuide.styles'

/**
 * Media size guide (FR-020a a FR-020d), informative only — the validation
 * that actually prevails is the size limit applied in FileToUpload/
 * BannerAddFormContent (FR-020, FR-021e). Collapsed by default.
 *
 * Content mirrors spec.md's "Guia de tamanhos de mídia", already adjusted
 * to the formats/limits this MVR1 accepts (500 KB instead of the
 * prototype's 10 MB; no Rich media, Nativo or Vídeo groups, since none of
 * those enter this creative path — see "Ajuste do guia aos formatos
 * aceitos" in spec.md). The autoplay-audio/pop-up restriction was dropped
 * for the same reason: it came from Google's guide and this path accepts no
 * video at all (2026-09-15 demo, SPEC 004 item 4.2).
 *
 * Layout (icon tile per group, 2-column grid, tip banner spanning both)
 * matches the prototype's media guide — see SizeGuide.styles.ts for the
 * source.
 */
const SizeGuide: React.FC = () => {
  const { t } = useAPPTranslation()

  return (
    <Panel
      title={t('rm:campaign.create.Banner.sizeGuide.title')}
      iconLeft={<LuImage />}
      isCollapsible
      initialCollapsibleState={false}
    >
      <GuideBody>
        <GuideTip>
          <Alert variant="informational">
            {t('rm:campaign.create.Banner.sizeGuide.minCreatives')}
          </Alert>
        </GuideTip>

        <GuideGroup>
          <GuideGroupIcon aria-hidden="true">
            <LuImage />
          </GuideGroupIcon>
          <div>
            <GuideGroupTitle>
              {t('rm:campaign.create.Banner.sizeGuide.image.title')}
            </GuideGroupTitle>
            <GuideList>
              <li>{t('rm:campaign.create.Banner.sizeGuide.image.formats')}</li>
              <li>{t('rm:campaign.create.Banner.sizeGuide.image.maxSize')}</li>
              <li>
                {t('rm:campaign.create.Banner.sizeGuide.image.commonSizes')}
              </li>
              <li>{t('rm:campaign.create.Banner.sizeGuide.image.tip')}</li>
            </GuideList>
          </div>
        </GuideGroup>

        <GuideGroup>
          <GuideGroupIcon aria-hidden="true">
            <LuSmartphone />
          </GuideGroupIcon>
          <div>
            <GuideGroupTitle>
              {t('rm:campaign.create.Banner.sizeGuide.mobile.title')}
            </GuideGroupTitle>
            <GuideList>
              <li>
                {t('rm:campaign.create.Banner.sizeGuide.mobile.initialLoad')}
              </li>
              <li>
                {t('rm:campaign.create.Banner.sizeGuide.mobile.commonSizes')}
              </li>
              <li>
                {t('rm:campaign.create.Banner.sizeGuide.mobile.interstitial')}
              </li>
            </GuideList>
          </div>
        </GuideGroup>
      </GuideBody>
    </Panel>
  )
}

export default SizeGuide
